import { eGENA_ProblemKategorie} from './ProblemKategorieABCDE'
import { eGENA_Patientengruppe } from './Patientengruppe';
import { eGENA_Organsystem } from './Organsystem';
import { eGENA_PlatzhalterArt } from './Platzhalter';
import { eGENA_ItemListe } from './ItemListe';
import { getErrorString } from './Error';
import { Logger } from './Logger';


export class eGENA_Checkliste extends eGENA_ProblemKategorie {
	public id : number;
	public titel : string;
	public übergeordnet : boolean;
	public generischerName : string;
	public patientengruppe : eGENA_Patientengruppe;
	public körpernavigator : eGENA_Organsystem[];
	public schlüsselwörterFürAlphabetischeSuche : string[];
	public reanimation : boolean = false;
	public zeitpunkt : string | undefined = undefined;
	public symptome : string | undefined;
	public differentialdiagnosen : string | undefined;
	public karteireiter : eGENA_ItemListe[] = [];
	constructor(
		auchEtwasMitProblemKategorien : eGENA_ProblemKategorie | undefined,
		id : number,
		titel : string,
		übergeordnet : boolean,
		generischerName : string,
		patientengruppe : eGENA_Patientengruppe,
		körpernavigator : eGENA_Organsystem[],
		a : boolean, b : boolean, c : boolean , d : boolean , e : boolean,
		schlüsselwörterFürAlphabetischeSuche : string[],
		reanimation: boolean,
		zeitpunkt : string | undefined = undefined,
		symptome : string | undefined,
		differentialdiagnosen : string | undefined,
		karteireiter : eGENA_ItemListe[]
	) {
		super(auchEtwasMitProblemKategorien);
		this.id = id;
		this.titel = titel;
		this.übergeordnet = übergeordnet;
		this.generischerName = generischerName;
		this.patientengruppe = patientengruppe;
		this.körpernavigator = körpernavigator;
		this.a = a;
		this.b = b;
		this.c = c;
		this.d = d;
		this.e = e;
		this.schlüsselwörterFürAlphabetischeSuche = schlüsselwörterFürAlphabetischeSuche;
		this.reanimation = reanimation;
		if (zeitpunkt == undefined || zeitpunkt.trim().length == 0)
			this.zeitpunkt = undefined;
		else
			this.zeitpunkt = zeitpunkt;

		this.symptome = symptome;
		this.differentialdiagnosen = differentialdiagnosen;
		this.karteireiter = karteireiter;
	}


	private platzhalterErsetzen(clientIp : string, text : string, mPlatzhalter : Map<string, string>, sPlatzhalter : Map<string, string>, tPlatzhalter : Map<string, string>) : string {
		let platzhalterInTextAufgelöst = text.replace(/\{([TMS]+):(.+?)\|(.+?)\}/gm, (match, $1, $2, $3) => {
			let platzhalterTyp : eGENA_PlatzhalterArt = $1;
			let benennung = $2.trim();
			let standardwert = $3.trim();
			let ersetzung : string | undefined = undefined;
			switch (platzhalterTyp) {
				case eGENA_PlatzhalterArt.Medikament:
					ersetzung = mPlatzhalter.get(benennung);
					break;
				case eGENA_PlatzhalterArt.Standort:
					ersetzung = sPlatzhalter.get(benennung);
					break;
				case eGENA_PlatzhalterArt.Telefonnummer:
					ersetzung = tPlatzhalter.get(benennung);
					break;
				default:
					throw new Error(`Der Platzhalter-Typ '${$1}' ist nicht bekannt. Checkliste: '${JSON.stringify(this, null, 4)}'`);
				}
			if (ersetzung == undefined) {
				let logger : Logger = new Logger("eGENA_Checkliste.platzhalterErsetzen", false, ["warn"]);
				logger.warn(clientIp, "Für den Platzhalter '", benennung, "' des Typs '", platzhalterTyp + "' ist keine Ersetzung definiert. Es wird daher der Standardwert '", standardwert , "' verwendet.");
				return standardwert; // Wenn es keine Übersetzung gibt, dann den Standardwert
				//throw new Error(`Für den Platzhalter '${match}' ist keine Ersetzung definiert. Checkliste: '${JSON.stringify(this, null, 4)}'`);
			}
			return ersetzung;
		});

		return platzhalterInTextAufgelöst;
	}

	public allePlatzhalterErsetzen(clientIp : string, mPlatzhalter : Map<string, string>, sPlatzhalter : Map<string, string>, tPlatzhalter : Map<string, string>) : void {
		if (this.symptome != undefined)
			this.symptome = this.platzhalterErsetzen(clientIp, this.symptome, mPlatzhalter, sPlatzhalter, tPlatzhalter);
		if (this.differentialdiagnosen != undefined)
			this.differentialdiagnosen = this.platzhalterErsetzen(clientIp, this.differentialdiagnosen, mPlatzhalter, sPlatzhalter, tPlatzhalter);

		for (const itemListe of this.karteireiter) {
			if (itemListe.items != undefined) {
				for (const item of itemListe.items) {
					item.label = this.platzhalterErsetzen(clientIp, item.label, mPlatzhalter, sPlatzhalter, tPlatzhalter);
					if (item.zusatzinformationen != undefined) {
						item.zusatzinformationen = this.platzhalterErsetzen(clientIp, item.zusatzinformationen, mPlatzhalter, sPlatzhalter, tPlatzhalter);
					}
				}
			}
		}
	}


	public static fromArray(objects : any[]) : eGENA_Checkliste[] {
		let result : eGENA_Checkliste[] = [];
		let logger : Logger = new Logger("eGENA_Checkliste", true, ["warn"]);

		logger.debug("fromArray: Extrahiere Daten für ", objects.length, " eGENA_Checkliste-Objekte");

		for (const object of objects) {
			logger.debug("fromArray: Extrahiere Daten für EINE eGENA_Checkliste...");
			logger.trace("fromArray: extrahiere Attribut 'id'...");
			if (!('id' in object))
				throw new Error("Der JSON-String ist nicht im erwarteten Format: Das Attribut 'id' ist nicht definiert. JSON-String: " + JSON.stringify(object));
			logger.trace("fromArray: extrahiere Attribut 'titel'...");
			if (!('titel' in object))
				throw new Error("Der JSON-String ist nicht im erwarteten Format: Das Attribut 'titel' ist nicht definiert. JSON-String: " + JSON.stringify(object));
			logger.trace("fromArray: extrahiere Attribut 'generischerName'...");
			if (!('generischerName' in object))
				throw new Error("Der JSON-String ist nicht im erwarteten Format: Das Attribut 'generischerName' ist nicht definiert. JSON-String: " + JSON.stringify(object));
			logger.trace("fromArray: extrahiere Attribut 'patientengruppe'...");
			if (!('patientengruppe' in object))
				throw new Error("Der JSON-String ist nicht im erwarteten Format: Das Attribut 'patientengruppe' ist nicht definiert. JSON-String: " + JSON.stringify(object));
			logger.trace("fromArray: extrahiere Attribut 'körpernavigator'...");
			if (!('körpernavigator' in object))
				throw new Error("Der JSON-String ist nicht im erwarteten Format: Das Attribut 'körpernavigator' ist nicht definiert. JSON-String: " + JSON.stringify(object));

			logger.trace("fromArray: extrahiere Attribute 'a, b, c, d, e'...");
			let a : boolean = false, b : boolean = false, c : boolean = false, d : boolean = false, e : boolean = false, reanimation : boolean = false;
			if ('a' in object)
				a = object.a;
			if ('b' in object)
				b = object.b;
			if ('c' in object)
				c = object.c;
			if ('d' in object)
				d = object.d;
			if ('e' in object)
				e = object.e;

			logger.trace("fromArray: extrahiere Attribut 'reanimation'...");
			if ('reanimation' in object)
				reanimation = object.reanimation;

			logger.trace("fromArray: extrahiere Attribut 'schlüsselwörterFürAlphabetischeSuche'...");
			if (!('schlüsselwörterFürAlphabetischeSuche' in object))
				throw new Error("Der JSON-String ist nicht im erwarteten Format: Das Attribut 'schlüsselwörterFürAlphabetischeSuche' ist nicht definiert. JSON-String: " + JSON.stringify(object));

			logger.trace("fromArray: extrahiere Attribut 'übergeordnet'...");
			if (!('übergeordnet' in object))
				throw new Error("Der JSON-String ist nicht im erwarteten Format: Das Attribut 'übergeordnet' ist nicht definiert. JSON-String: " + JSON.stringify(object));

			logger.trace("fromArray: extrahiere Attribut 'zeitpunkt'...");
			let zeitpunkt : string | undefined = undefined;
			if ('zeitpunkt' in object) {
				zeitpunkt = object.zeitpunkt;
			}

			logger.trace("fromArray: extrahiere Attribut 'symptome'...");
			let symptome : string | undefined = undefined;
			if ('symptome' in object && object.symptome != undefined && object.symptome.trim().length > 0) {
				symptome = object.symptome;
			}

			logger.trace("fromArray: extrahiere Attribut 'differentialdiagnosen'...");
			let differentialdiagnosen : string | undefined = undefined;
			if ('differentialdiagnosen' in object && object.differentialdiagnosen != undefined && object.differentialdiagnosen.trim().length > 0) {
				differentialdiagnosen = object.differentialdiagnosen;
			}

			logger.trace("fromArray: extrahiere Attribut 'karteireiter'...");
			let karteireiter : eGENA_ItemListe[] = [];
			if ('karteireiter' in object && object.karteireiter != undefined) {
				if (object.karteireiter instanceof Array) {
					let rohdatenArray : any[] = <Array<any>>object.karteireiter;
					logger.debug("getData: extrahiere 'eGENA_ItemListe[]' aus Rohdaten-Array der Länge ", rohdatenArray.length);
					karteireiter = eGENA_ItemListe.fromJSONarray(rohdatenArray);
				}
				else {
					throw new Error("Der JSON-String ist nicht im erwarteten Format: Das Attribut 'karteireiter' ist kein Array. JSON-String: " + JSON.stringify(object.karteireiter));
				}
			}
			else
				throw new Error("Der JSON-String ist nicht im erwarteten Format: Das Attribut 'karteireiter' ist nicht definiert. JSON-String: " + JSON.stringify(object));

			logger.trace("fromArray: erzeuge ein Objekt eGENA_Checkliste aus den Attributen ", object.id, ", ", object.titel, ", ", object.übergeordnet);
			let checkliste = new eGENA_Checkliste(
				undefined, Number(object.id),
				object.titel, object.übergeordnet, object.generischerName, object.patientengruppe, object.körpernavigator,
				a, b, c, d, e,
				object.schlüsselwörterFürAlphabetischeSuche, reanimation,
				zeitpunkt, symptome, differentialdiagnosen, karteireiter
			);

			logger.trace("fromArray: eGENA_Checkliste an Array anfügen...");
			result.push(checkliste);
		}

		return result;
	}

	public static fromJSONstring(jsonString : string) : eGENA_Checkliste[] {
		try {
			let objects : any[] = [];
			if (jsonString.startsWith("[")) {
				objects = JSON.parse(jsonString);
			}
			else {
				objects.push(JSON.parse(jsonString));
			}

			return eGENA_Checkliste.fromArray(objects);
		}
		catch (e) {
			throw new Error("Fehler beim Parsen JSON->eGENA_Checkliste: " + getErrorString(e) + "\n\nJSON-String = '" + jsonString + "'");
		}
	}
}


// WEBPACK FOOTER //
// ./src/visionet/Checkliste.ts